import { Component, Input, OnChanges, OnInit, SimpleChanges, TemplateRef, OnDestroy } from '@angular/core';
import { CommonModule } from '@angular/common';
import { ActivatedRoute, Router } from '@angular/router';
import { NgbModalOptions } from '@ng-bootstrap/ng-bootstrap';
import { BsModalRef, BsModalService } from 'ngx-bootstrap/modal';
import { JobService } from 'src/app/services/job.service';
import { JobModel } from 'src/app/services/jobModel';
import { SearchData } from 'src/app/services/searchData';
import { ApiService } from './../../../services/api.service';
import { AppSettings } from './../../../services/AppSettings';
import { UtilService } from './../../../services/util.service';
import { TimezoneDatePipe } from '../../../timezone-date.pipe';
import { CommonSkeletonComponent } from '../../../skeleton/common-skeleton/common-skeleton.component';
import { InfiniteScrollModule } from 'ngx-infinite-scroll';
import { ConnectionTemplateComponent } from '../../../templates/connection-template/connection-template.component';
import { MessageWidgetComponent } from '../../../widget/message-widget/message-widget.component';
import { NG_ICON_DIRECTIVES } from '@ng-icons/core';
import { Subject } from 'rxjs';
import { debounceTime } from 'rxjs/operators';

import { ScrollIntentGate } from 'src/app/shared/scroll-intent-gate';
@Component({
  selector: 'app-jobliked-list',
  standalone: true,
  imports: [CommonModule, TimezoneDatePipe, CommonSkeletonComponent, InfiniteScrollModule,
ConnectionTemplateComponent, MessageWidgetComponent,
    NG_ICON_DIRECTIVES,
  ],
  templateUrl: './jobliked-list.component.html',
  styleUrls: ['./jobliked-list.component.scss'],
  inputs: ['jobDetails']
})
export class JoblikedListComponent implements OnDestroy, OnInit, OnChanges {
  // User-intent gate (src/app/shared/scroll-intent-gate.ts): after a page
  // lands, the next page needs a NEW physical input — a fast wheel flick's
  // smooth-scroll tail must not chain pages on its own.
  readonly scrollGate = new ScrollIntentGate({
    onArmAtBottom: () => this.onScrollDown(),
    isAtBottom: () => ScrollIntentGate.nearBottom(document.querySelector('.jc-v3-entity-details-body')),
  });

  ngOnDestroy(): void {
    this.scrollGate.detach();
  }

  @Input() designVersion: string = 'v2';
  connectionRequestRef: BsModalRef;
  connectionStatus: string;
  values: any;
  counterpartsDetails: any;
  jobId: any;
  jobDetails: JobModel;
  url = AppSettings.photoUrl;
  LoginUserId=localStorage.getItem('userId')
  constructor(private api: ApiService, private modalService: BsModalService,private searchData: SearchData, private router: Router, private util: UtilService,
    private a_route: ActivatedRoute, private JobServicecolor: JobService) {
  }
  ngOnChanges(changes: SimpleChanges): void {
    if (changes.jobDetails.currentValue) {
      this.jobDetails = changes.jobDetails.currentValue;
      if (this.jobDetails.jobId) {
        this.likedByList=[];
        this.searchConfig.pageNumber=0;
        this.stopscrollFlag = false;
        // Invalidate any in-flight page fetch and unlock the loadAPIcall
        // entry guard — a tab re-click during pagination must reload
        // fresh, not skip + append the stale page into the cleared list.
        this.fetchGeneration++;
        this.loadAPIcall = false; this.scrollGate.pageLanded();
        this.getViews();
      }
    }
  }
  getInitialstwo(firstname: string, lastname: string): string {
    return this.JobServicecolor.getInitialsparam(firstname, lastname);
  }
  getColortwo(firstname: string, lastname: string): string {
    return this.JobServicecolor.getColorparam(firstname, lastname);
  }
  getTextColor(firstname: string, lastname: string): string {
    return this.JobServicecolor.getTextColor(firstname, lastname);
  }
  likedByList: any = []
  ngOnInit() {

    this.scrollGate.attach();
    this.searchData.setNUllCheck("jobs-liked");
    this.scrollSubject.pipe(
      debounceTime(100)
    ).subscribe(() => {
      if (this.loadAPIcall || this.stopscrollFlag) return;
      this.getViews();
    });
  }
  searchConfig: any = {
    pageNumber: 0,
  }
  profile(val) {
    let values: any = {}
    values.userId = val;
    this.router.navigate(["personalProfile"], { queryParams: values });
  }
  loadAPIcall:boolean=false;
  // Stale-response gate: bumped on every list reset (tab re-click). A fetch
  // captures the value at launch; a reset mid-flight makes the late response
  // a no-op instead of appending old rows into the cleared list.
  private fetchGeneration = 0;
  getViews() {
    // Double-clicking the Likes tab in the parent re-emits a fresh
    // `selectedJobData` reference twice in quick succession, which fires
    // ngOnChanges → getViews() twice. Without this guard both in-flight
    // requests push the same page-0 results and the list shows duplicates.
    if (this.loadAPIcall) {
      return;
    }
    this.searchConfig.jobId = this.jobDetails.jobId
    this.searchConfig.limit = 10
    // this.util.startLoader()
    this.loadAPIcall=true
    const gen = this.fetchGeneration;
    this.api.create('jobs/findJobsLikedBy', this.searchConfig).subscribe(res => {
      if (gen !== this.fetchGeneration) return;
      // this.util.stopLoader()
      this.loadAPIcall = false; this.scrollGate.pageLanded();if (res.code == '00000') {
        if (res.data != null && res.data.likedByList.length != 0) {
          if (res.data.likedByList.length < 9) {
            this.stopscrollFlag = true
          } else {
            this.stopscrollFlag = false
            this.searchConfig.pageNumber++;
          }
          res.data.likedByList.forEach(ele => {
            if (ele.logo != null) {
              ele.logo = AppSettings.photoUrl + ele.logo
            }else{
              ele.logo=null;
            }
            // Defence-in-depth dedup: if a stale response slips past the
            // loadAPIcall guard (e.g. error path leaves it flipped), skip
            // entries already in the list keyed by userId.
            const exists = this.likedByList.find(item => item.userId === ele.userId);
            if (!exists) {
              this.likedByList.push(ele)
            }
          })
        } else if (res.data != null && res.data.likedByList.length == 0) {
          this.stopscrollFlag = true
        }
      }
    }, () => {
      if (gen !== this.fetchGeneration) return;
      this.loadAPIcall = false; this.scrollGate.pageLanded();
    })
  }
  stopscrollFlag: boolean = false
  scrollSubject = new Subject<void>();
  onScrollDown() {
    if (!this.loadAPIcall && !this.stopscrollFlag && this.scrollGate.armed) {
      this.scrollSubject.next();
    }
  }
  chatuser(values,connectionTemplate?: TemplateRef<any>){
    if (values.connectionStatus === 'CONNECTED') {
      this.openMessage(values)
    } else if (values.connectionStatus !== 'CONNECTED') {
      this.openMessage(values)
      // to be used later
      // this.openConnectionTemplate(values.connectionStatus, values, connectionTemplate);
    }
  }
  seletedChatItem:any;
  messageData: any;
  userId = localStorage.getItem('userId');
  messagemodelflag: any;
  openMessage(seletedItem) {
    if (seletedItem.userId == this.userId) {
      seletedItem.owner = true;
    } else {
      seletedItem.owner = false;
    }
    setTimeout(() => {
      seletedItem.userId = seletedItem.userId;
      this.seletedChatItem = seletedItem;
      this.messageData = [];
      this.messagemodelflag = true;
      seletedItem.groupType = "USER";
      seletedItem.messageType = "USER";
      seletedItem.onlyuser ="USER";
      seletedItem.id = seletedItem.userId;
      this.messageData = seletedItem;
    }, 1000);
  }
    closeMessage(event) {
    this.messagemodelflag = false;
  }
  openConnectionTemplate(connectionStatus, values, connectionTempate?: TemplateRef<any>) {
    this.connectionStatus = connectionStatus;
    this.values = values;
    const initialState: NgbModalOptions = {
      backdrop: 'static',
      keyboard: false,
      size: 'sm',
    };
    this.api.query("user/" + this.values.userId).subscribe(res => {
      if (res.code == '00000') {
        this.counterpartsDetails = res;
        this.connectionRequestRef = this.modalService.show(connectionTempate, initialState);
      }
    })
  }
}
